/**
 * Verti DEU PL API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { BankDetails } from './bankDetails';
import { Household } from './household';
import { DrivingLicense } from './drivingLicense';
import { Gender } from './gender';
import { LegalPerson } from './legalPerson';
import { Contact } from './contact';
import { LegalStructure } from './legalStructure';
import { PersonTitle } from './personTitle';
import { PointsInFlensburg } from './pointsInFlensburg';
import { MaritalStatus } from './maritalStatus';
import { OccupationBranche } from './occupationBranche';
import { PartnerRelationship } from './partnerRelationship';
import { Employment } from './employment';
import { HomeOwnership } from './homeOwnership';
import { PartnerAddress } from './partnerAddress';
import { Person } from './person';

/**
 * Represents single person or legal person resp. company.
 */
/**
 * @type Partner
 * Represents single person or legal person resp. company.
 * @export
 */
export type Partner = LegalPerson | Person;
